import React, { useEffect, useState } from "react";
import API from "../../../utils";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Milestones = () => {
    const uid = localStorage.getItem("user_id");
    const [formData, setFormData] = useState({
        Milestonesingular: "",
        Milestonesplural: "",

    });





    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        formDataToSend.append('user_id', uid);
        formDataToSend.append('milestone_singular', formData.Milestonesingular);
        formDataToSend.append('milestone_prular', formData.Milestonesplural);

        try {
            const response = await axios.post(
                `${API.BASE_URL}${API.ENDPOINTS.add_update_terminology_Milestones}`,
                formDataToSend,
                {
                    headers: {
                        Authorization: `${API.AUTHORIZATION_TOKEN}`,
                    },
                }
            );

            if (response.data.status === "success") {
                toast.success(response.data.message);
                fetchData();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Error during task submission:", error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append('user_id', uid);

        try {
            const response = await axios.post(
                `${API.BASE_URL}${API.ENDPOINTS.get_all_terminology_Milestones}`,
                formDataToSend,
                {
                    headers: {
                        Authorization: `${API.AUTHORIZATION_TOKEN}`,
                    },
                }
            );

            if (response.data.status === 'success') {
                const data = response.data.data[0];
                setFormData({
                    Milestonesingular: data.milestone_singular || "",
                    Milestonesplural: data.milestone_prular || "",

                });
            } else {
            }
        } catch (error) {
            console.error('Error during task fetching:', error);
        }
    };


    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h5 className="card-title mb-0"><i className="fa fa-flag mx-2"></i>Milestones</h5>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <div className="form-group mb-2">
                                <label className="col-sm-12 col-form-label"><b>Milestone (singular)</b></label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Enter Measurabile (singular)"
                                    name="Milestonesingular"
                                    value={formData.Milestonesingular}
                                    onChange={handleChange}
                                />

                            </div>
                        </div>

                        <div className="col-sm-12 col-md-6">
                            <div className="form-group mb-2">
                                <label className="col-sm-12 col-form-label"><b>Milestones (plural)</b></label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Enter Milestones (plural)"
                                    name="Milestonesplural"
                                    value={formData.Milestonesplural}
                                    onChange={handleChange}
                                />

                            </div>
                        </div>
                        <div className="d-flex justify-content-end align-content-center">
                            <button type="submit" className="btn btn-success" onClick={handleSubmit}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Milestones;